module.exports = {"230803007":"西林街道","230803008":"建设街道","230803009":"长安街道","230803010":"学府街道","230803011":"桥南街道","230803198":"向阳区直辖村级区划"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230803.json
// module id = 855
// module chunks = 0